export default __webpack_public_path__ + "static/media/1575.ebb704dc.png";